import { connect } from 'react-redux'

import { setSlug } from './reducer'

const mapStateToProps = (state) => {
    return {
        slug: state?.components?.document?.slug,
    }
}

const mapDispatchToProps = { setSlug }

const hocDocumentPopUp = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocDocumentPopUp
